/**
 * Messaging UI Configuration
 * Easy to customize - change colors, text, or swap entire components!
 *
 * WIREFRAME DESIGN - Feel free to replace with your own UI
 * Follow the same pattern as authConfig for easy maintenance
 */

import { ConversationView } from '../features/messaging/ConversationView'
import { MessageBubble } from '../features/messaging/MessageBubble'

/**
 * Messaging Screen Components
 * Swap these to completely change the UI
 */
export const messagingComponents = {
  conversationView: ConversationView,
  messageBubble: MessageBubble
}

/**
 * Color Scheme - Tailwind classes
 * Change these to match your brand
 */
export const messagingColors = {
  // Message bubbles
  sentMessage: 'bg-blue-600 text-white',
  receivedMessage: 'bg-pink-100 text-gray-900',

  // Input area
  inputBackground: 'bg-white border-pink-300',
  inputFocus: 'border-blue-500 ring-blue-500',
  sendButton: 'bg-blue-600 hover:bg-blue-700 text-white',

  // Header
  headerBackground: 'bg-pink-50 border-pink-200',

  // Timestamps
  timestamp: 'text-gray-500 text-xs',

  // Loading/empty states
  emptyState: 'text-gray-500',
  loadingSpinner: 'text-blue-600'
}

/**
 * UI Text
 * All text used in messaging interface
 */
export const messagingText = {
  conversation: {
    title: 'Message Creator',
    emptyState: 'No messages yet. Say hi! 👋',
    loadingMessages: 'Loading messages...',
    typingIndicator: 'Creator is typing...',
    inputPlaceholder: 'Type your message...',
    sendButton: 'Send',
    errorSending: 'Failed to send message. Please try again.',
    errorLoading: 'Failed to load messages. Please refresh.',
    today: 'Today',
    yesterday: 'Yesterday'
  }
}

/**
 * Behavior Configuration
 */
export const messagingBehavior = {
  // How many messages to load initially
  initialLoadCount: 50,

  // How many more messages to load when scrolling up
  loadMoreCount: 50,

  // Auto-scroll to bottom on new message
  autoScrollOnNewMessage: true,

  // Show typing indicator when creator is typing
  showTypingIndicator: true,

  // Auto-mark messages as read when viewed
  autoMarkAsRead: true,

  // Debounce typing indicator (ms)
  typingIndicatorDebounce: 1000,

  // Message timestamp format
  timestampFormat: 'relative' // 'relative' | 'absolute'
}

/**
 * Real-Time Configuration
 */
export const realtimeConfig = {
  // Enable real-time message updates
  enabled: true,

  // Reconnect automatically if connection drops
  autoReconnect: true,

  // How long to wait before reconnecting (ms)
  reconnectDelay: 2000
}
